import { render, staticRenderFns } from "./vendorOrdersHistory.vue?vue&type=template&id=717d659f&scoped=true"
import script from "./vendorOrdersHistory.vue?vue&type=script&lang=js"
export * from "./vendorOrdersHistory.vue?vue&type=script&lang=js"
import style0 from "./vendorOrdersHistory.vue?vue&type=style&index=0&id=717d659f&prod&lang=scss&scoped=true"
import style1 from "./vendorOrdersHistory.vue?vue&type=style&index=1&id=717d659f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717d659f",
  null
  
)

export default component.exports